export default __webpack_public_path__ + "static/2166-7e69954e331b455cdb1cfa6a7bdb2b26.gif";